import {gearsetSlice} from './gearset';

export const sliceReducers = {
  gearset: gearsetSlice.reducer
};

export const sliceActions = {
  gearset: gearsetSlice.actions
};
